var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 883,
    height: 343,
    viewBox: "0 0 883 343",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 883,
    height: 343
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404",
    "data-name": 404,
    clipPath: "url(#clip-_404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(28.708 34.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M5284.848,7101.226l-120.62,20.9-4.98-58.168L5250.9,6931.37l69.981-7.931,10.56,133.6,49.735-6.116,2.927,41.715-39.807,8.585,3.314,57.748-62.763,10.978v-68.725",
    transform: "translate(-5119.507 -6891.27)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M5241.612,6948.818l-56.251,88.234,69.237-16.489Z",
    transform: "translate(-5091.791 -6862.25)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M5288.509,6940.6l-48.438-32.169-51.217,7.747,35.71,32.637Z",
    transform: "translate(-5087.794 -6908.431)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M5241.946,6911.252l-99.791,141.979,38.26,22.749,3.39,58.122-41.649-24.811V7055.8",
    transform: "translate(-5141.196 -6903.716)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M5241.456,7076l-42.771-26.77v-33.944l42.771-9.08Z",
    transform: "translate(-5076.554 -6796.619)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M5235.667,6992.887l-37.613-22.393",
    transform: "translate(-5077.274 -6837.462)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M5290.265,6995.765l-32.587-24.731-18,3.3v27.993Z",
    transform: "translate(-5029.675 -6836.847)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M5198.686,7020.313l43.032,14.761",
    transform: "translate(-5076.554 -6780.494)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M5198.686,7014.31l41.321,14",
    transform: "translate(-5076.554 -6787.36)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M5184.49,7020.137l-42.783-22.15",
    transform: "translate(-5141.707 -6806.024)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M5141.707,6992.088l42.136,19.639",
    transform: "translate(-5141.707 -6812.77)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M5142.155,6985.631l38.166,19.115",
    transform: "translate(-5141.196 -6820.152)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M5147.03,6970.5l36.28,24.072",
    transform: "translate(-5135.621 -6837.456)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M5151.057,6964.234l37.868,25.159",
    transform: "translate(-5131.015 -6844.62)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M5192.253,6982.521l-37.526-23.276",
    transform: "translate(-5126.82 -6850.328)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M5195.679,6977.328l-36.589-23.721",
    transform: "translate(-5121.831 -6856.773)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M5161.667,6948.818l37.215,21.388",
    transform: "translate(-5118.883 -6862.25)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M5166.8,6943.481l36.548,21.79",
    transform: "translate(-5113.014 -6868.353)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M5172.236,6937.474l34.181,22.19",
    transform: "translate(-5106.796 -6875.22)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M5176.159,6928.5l36.449,25.82",
    transform: "translate(-5102.311 -6885.479)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M5181.776,6921.086l36.243,26.776",
    transform: "translate(-5095.887 -6893.961)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M5199.479,6909.9l33.743,31.307",
    transform: "translate(-5075.645 -6906.756)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M5207.35,6909.9l35.519,27.728",
    transform: "translate(-5066.644 -6906.756)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M5225.318,6972.561l-23.657-8.682",
    transform: "translate(-5073.15 -6845.027)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M5218.911,6966.383l-12.768-9.038",
    transform: "translate(-5068.023 -6852.499)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M5208.49,6989.67c-2.4-.353-18.38-7.572-18.38-7.572",
    transform: "translate(-5086.358 -6824.193)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M5221.207,6992.359l-27.242-16.068",
    transform: "translate(-5081.95 -6830.833)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M5256.241,6992.9l-13.346-20.248",
    transform: "translate(-5025.999 -6834.994)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 318.714, 16.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M106.446,4.085c59.043-.8,102.683,50.73,106.859,126.3,2.4,43.375-6.57,79.236-28.062,102.381-15.2,16.372-37.489,25.948-66.739,25.948-68.662,0-113.415-53.748-113.415-128.329S47.4,4.886,106.446,4.085Z",
    transform: "translate(41.016 34.444)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M66.994,4.08c40.455-.529,49.619,48.945,51.659,90.768s-12.825,72.772-44.87,73.934-51.55-33.127-59.7-76.634S26.13,4.614,66.994,4.08Z",
    transform: "translate(83.475 76.632)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M5436.63,6935.078s10.546,9.668,18.1,32.563,6.505,51.336,3.843,68.092c-5.592,35.2-44.505,38.835-44.505,38.835",
    transform: "translate(-5295.129 -6853.05)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M78.912,266.524S-8.932,244.632-33.574,190.317C-53.794,145.75-41.14,63.029-30.436,36.511c13.393-33.177,50.026-56.073,93.877-58.8s91.407,54,91.407,54",
    transform: "translate(45.632 22.395)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M5415.15,7015.421,5367.5,7001.3",
    transform: "translate(-5348.382 -6775.816)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M5409.789,7007.813l-46.53-17.433",
    transform: "translate(-5353.229 -6788.299)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M5406.736,7002.549l-47.4-26.411",
    transform: "translate(-5357.722 -6804.587)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M5404.685,6990.628l-46.1-23.048",
    transform: "translate(-5358.58 -6814.374)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M5359.2,6956.095l43.691,30.013",
    transform: "translate(-5357.868 -6827.505)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M5359.332,6946.476l46.649,28.513",
    transform: "translate(-5357.722 -6838.506)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M5362.271,6935.436l42.2,33.159",
    transform: "translate(-5354.358 -6851.13)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M5364.84,6924.927l45.174,36.387",
    transform: "translate(-5351.421 -6863.148)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M5370.213,6914.929l44.419,36.762",
    transform: "translate(-5345.278 -6874.581)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M5379.586,6906.168l38.292,38.505",
    transform: "translate(-5334.561 -6884.597)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M5387.443,6900.634l39.235,39.515",
    transform: "translate(-5325.572 -6890.926)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M5397.45,6898.315l40.161,35.78",
    transform: "translate(-5314.132 -6893.578)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M5412.768,6896.1l32.44,37.164",
    transform: "translate(-5296.616 -6896.104)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M5466.613,6962.239l-34.134-14.393",
    transform: "translate(-5274.076 -6836.939)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M5471.4,6970.357l-37.36-12.856",
    transform: "translate(-5272.29 -6825.897)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M5435.757,6966.6l36.536,15.429",
    transform: "translate(-5270.328 -6815.49)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M5435.757,6976.138l35.421,17.286",
    transform: "translate(-5270.328 -6804.587)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M5434.041,6986.489l33.707,18.908",
    transform: "translate(-5272.29 -6792.75)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M5428.112,6992.339l41.65,18.795",
    transform: "translate(-5279.069 -6786.06)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M5463.82,7021.041l-39.484-24.657",
    transform: "translate(-5283.387 -6781.436)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M5418.5,6998.514l23.652,24.125",
    transform: "translate(-5290.062 -6779.001)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(603.181 27.933) rotate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78-2",
    "data-name": "Path 78",
    d: "M5285.182,7107.6l-120.954,14.524-4.98-58.168,99.929-134.285,64.077-9.728,7.521,143.514,50.4-12.533,2.927,41.715-39.807,8.585,3.314,57.748-62.763,10.978.334-62.35",
    transform: "translate(-5119.507 -6891.27)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79-2",
    "data-name": "Path 79",
    d: "M5240.507,6949.072l-55.146,87.98,69.94-5.2Z",
    transform: "translate(-5087.744 -6861.46)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80-2",
    "data-name": "Path 80",
    d: "M5291.788,6936.285h0l-51.717-27.854-51.217,7.747L5231.24,6946Z",
    transform: "translate(-5087.794 -6908.431)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81-2",
    "data-name": "Path 81",
    d: "M5242.255,6912.556l-100.1,140.675,38.26,22.749,3.39,58.122-41.649-24.811V7055.8",
    transform: "translate(-5141.196 -6903.716)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82-2",
    "data-name": "Path 82",
    d: "M5241,7075.417l-42.31-26.181.343-30.161,41.882-6Z",
    transform: "translate(-5076.554 -6796.619)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83-2",
    "data-name": "Path 83",
    d: "M5238.725,7003.028l-40.671-32.534",
    transform: "translate(-5073.228 -6836.673)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84-2",
    "data-name": "Path 84",
    d: "M5290.374,6994.95l-32.7-23.916-18,3.3,1.757,33.529Z",
    transform: "translate(-5029.675 -6836.847)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85-2",
    "data-name": "Path 85",
    d: "M5198.686,7020.313l43.032,14.761",
    transform: "translate(-4048.582 -7438.628) rotate(8)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86-2",
    "data-name": "Path 86",
    d: "M5198.686,7014.31l41.321,14",
    transform: "translate(-4047.626 -7445.427) rotate(8)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87-2",
    "data-name": "Path 87",
    d: "M5184.49,7020.137l-42.783-22.15",
    transform: "translate(-5141.707 -6806.024)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88-2",
    "data-name": "Path 88",
    d: "M5141.707,6992.088l42.136,19.639",
    transform: "translate(-5141.707 -6812.77)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89-2",
    "data-name": "Path 89",
    d: "M5142.155,6985.631l38.166,19.115",
    transform: "translate(-5141.196 -6820.152)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90-2",
    "data-name": "Path 90",
    d: "M0,0,39.528,24.763",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 12.872, 134.233)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91-2",
    "data-name": "Path 91",
    d: "M0,0,41.258,25.881",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 21.809, 120.067)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92-2",
    "data-name": "Path 92",
    d: "M40.887,23.942,0,0",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 30.003, 108.745)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-2",
    "data-name": "Path 93",
    d: "M39.865,24.4,0,0",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 39.771, 95.938)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94-2",
    "data-name": "Path 94",
    d: "M0,0,40.55,22",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 45.432, 85.152)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95-2",
    "data-name": "Path 95",
    d: "M0,0,39.822,22.411",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 57.021, 72.943)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96-2",
    "data-name": "Path 96",
    d: "M0,0,37.241,22.826",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 69.267, 59.23)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97-2",
    "data-name": "Path 97",
    d: "M0,0,39.71,26.564",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 77.757, 39.102)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98-2",
    "data-name": "Path 98",
    d: "M0,0,41.339,28.961",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 90.32, 22.26)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99-2",
    "data-name": "Path 99",
    d: "M5195.837,6911.739l37.385,29.464",
    transform: "translate(-5075.645 -6906.756)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100-2",
    "data-name": "Path 100",
    d: "M5203.826,6910l43.073,25.964",
    transform: "translate(-5066.644 -6906.756)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101-2",
    "data-name": "Path 101",
    d: "M5228.366,6982.58l-26.7-18.7",
    transform: "translate(-5879.236 -6156.803) rotate(-7)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102-2",
    "data-name": "Path 102",
    d: "M5218.911,6966.383l-12.768-9.038",
    transform: "translate(-5875.059 -6164.844) rotate(-7)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103-2",
    "data-name": "Path 103",
    d: "M5207.275,6995.434c-2.4-.353-17.166-13.335-17.166-13.335",
    transform: "translate(-4192.566 -7406.073) rotate(7)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-2",
    "data-name": "Path 104",
    d: "M5221.815,6999.413l-27.851-23.122",
    transform: "translate(-4187.382 -7412.127) rotate(7)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105-2",
    "data-name": "Path 105",
    d: "M5261.919,6997.6l-19.023-24.948",
    transform: "translate(-5025.999 -6834.994)",
    fill: "none",
    stroke: "#7a9eef",
    strokeLinecap: "round",
    strokeWidth: 6
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.6acd8d9d.svg";
export { ForwardRef as ReactComponent };